<template>
  <div class="left">
    <left-header class="item"></left-header>
    <left-footer class="item"></left-footer>
  </div>
</template>

<script>
import LeftHeader from "@/components/left/items/LeftHeader";
import LeftFooter from "@/components/left/items/LeftFooter";
export default {
  name: "Left",
  components: {
    LeftHeader,
    LeftFooter,
  },
};
</script>

<style lang="less" scoped>
.left {
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  width: 100%;
  padding: 1.25rem;
  box-sizing: border-box;
  & > div {
    width: 100%;
    height: 45%;
  }
  .item {
    background: url("~@/assets/image/框A.png");
    background-size: 100% 100%;
  }
}
</style>